module.exports = __webpack_public_path__ + "img/Angiogenesis-BRCA_10X_Section2.ef2ad6fa.png";